import React from "react";

export const isCheckedAddress = ({ address, institution, principal, type }) => {
  let defaultProjection = "";
  if (type === typeAddress.postal) {
    defaultProjection = "defaultAddress";
  } else {
    defaultProjection = "defaultLocation";
  }

  if (institution !== null) {
    return institution[defaultProjection] === address._id;
  }

  if (principal !== null) {
    return principal.defaultAddress === address._id;
  }
};

export const typeAddress = {
  maps: "maps",
  postal: "postal",
};


export const renderAdress = (adress, isDefault = false, fromInstitution) => {
  if (adress === null) {
    return "- ";
  }

  if (adress?.type === typeAddress.postal) {
    return (
      <>
        {adress?.description && <b>{adress.description}</b>}
        {isDefault && <cite> - Par défaut</cite>}
        {adress.principal !== null && adress.principal !== undefined ? (
          <cite> - Mandant {adress.principal?.name}</cite>
        ) : null}
        {fromInstitution?._id !== adress?.institution?._id ? (
          <cite> - Institution {adress.institution?.name}</cite>
        ) : null}
        {adress?.external === true && (
          <cite> - *Institution externe, facture par courrier postal</cite>
        )}
        <br />
        <span>
          {adress?.beneficiary} {adress?.person && `, ${adress.person}`}
          <br />
          {adress?.street} {adress?.number}
          {adress?.complement && ` - ${adress.complement}`} - {adress?.zip}{" "}
          {adress?.city}
        </span>
      </>
    );
  }

  if (adress?.type === typeAddress.maps) {
    return (
      <>
        {adress.location} {isDefault && <cite> - Par défaut</cite>} <br />
        <b>{adress.maps}</b>
      </>
    );
  }
};

export const renderStringAddress = (address, isDefault = false) => {
  if (!address) {
    return "- ";
  }

  let addressString = "";

  if (address.description) {
    addressString += `${address.description}`;
  }

  if (isDefault) {
    addressString += addressString ? " - Par défaut" : "Par défaut";
  }

  if (address.external === true) {
    addressString += addressString
      ? " - *Institution externe, facture par courrier postal"
      : "*Institution externe, facture par courrier postal";
  }

  addressString += addressString ? "\n" : "";

  let details = `${address.beneficiary || ""}`;
  if (address.person) {
    details += `, ${address.person}`;
  }

  details += `\n${address.street || ""} ${address.number || ""}`;
  if (address.complement) {
    details += ` - ${address.complement}`;
  }
  details += ` - ${address.zip || ""} ${address.city || ""}`;

  addressString += details;

  return addressString;
};
